import { useSuspenseQuery } from '@tanstack/react-query';
import i18n from './i18n';
import { getLanguageOptions } from '@generated';

const STORAGE_KEY = 'app_translations';

export function useTranslations(language: string) {
	return useSuspenseQuery({
		...getLanguageOptions(language, result => {
			i18n.addResourceBundle(language, 'translation', result, true, true);
		}),
		staleTime: Infinity,
		gcTime: Infinity
	});
}
